import { AppState} from '../app.state';

// Get the settins of the current portal
export const activities = (state: AppState) => state.activities
